// ========================================================
// FAST HIT Website — App Layout Shell
// Wraps authenticated user pages (/app/*)
// ========================================================

import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '../common/ScrollToTop';

export function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="main-content app-content">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
